export default (values) => () => {
    const newValues = {};

    if (values.mode) newValues.mode = values.mode.toUpperCase();
    if (values.expanded_sidebar)
        newValues.expanded_sidebar = values.expanded_sidebar;
};
